import { dateTimeStringWithTz } from '@mnd-frontend/dates';

interface Archived {
  variant: 'inactive';
  materialStatus: 'archived';
  label: string;
}

interface Draft {
  variant: 'inactive';
  materialStatus: 'draft';
  label: string;
}

interface GetMaterialStatus {
  variant: 'info' | 'active';
  materialStatus: 'scheduled' | 'published';
  label: string;
  publishedTime: null | string;
}

export const getMaterialStatus = (
  draft: boolean,
  isScheduled: boolean,
  publishedAt: Date | string | null,
  timezone: string,
  locale: string,
  sourceIsTrusted?: boolean,
  type?: string,
  archived?: boolean,
): GetMaterialStatus | Draft | Archived => {
  if (archived) {
    return {
      variant: 'inactive',
      materialStatus: 'archived',
      label: 'Archived',
    };
  }

  if (draft || !publishedAt) {
    if (sourceIsTrusted === false) {
      return {
        variant: 'inactive',
        materialStatus: 'draft',
        label: 'publish_components_badge_review_pending',
      };
    }
    return {
      variant: 'inactive',
      materialStatus: 'draft',
      label: 'publish_components_badge_draft',
    };
  }

  if (isScheduled) {
    return {
      variant: 'info',
      materialStatus: 'scheduled',
      label: 'publish_components_badge_scheduled',
      publishedTime:
        type !== 'Resource' ? dateTimeStringWithTz(publishedAt, timezone, locale) : null,
    };
  }
  return {
    variant: 'active',
    materialStatus: 'published',
    label: 'publish_components_badge_published',
    publishedTime: type !== 'Resource' ? dateTimeStringWithTz(publishedAt, timezone, locale) : null,
  };
};
